export default {
    component: 'fire_alarm',
    name: 'fire_alarm',
    fields: [{
        name: 'Plant ID',
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true
      },
      {
        name: 'Block ID',
        param: 'block_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> Should always start from ID **"1"**`
      },
      {
        name: 'Inverter Room',
        param: 'inverter_room',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block, room id should start from **"1"**`
      },
      {
        name: 'Fire Alarm ID',
        param: 'fire_alarm_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block-room, fire alarm id should start from **"1"**`
      },
      {
        name: 'Reading Frequency',
        param: 'reading_frequency',
        type: 'number',
        description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
      },
      {
        name: 'Latitude',
        param: 'lat',
        type: 'number',
      },
      {
        name: 'Longitude',
        param: 'long',
        type: 'number',
      },
      {
        name: 'Make',
        param: 'make',
        type: 'text',
      },
      {
        name: 'Device Name',
        param: 'device_name',
        type: 'text',
        description: `> For each block device name should be unique`
      },
      {
        name: 'Header Name',
        param: 'header_names',
        type: 'text',
        description:`HT Panel / SCADA Room Ceiling, Inverter Area / SCADA Room, MCP / Conference Room, Conf.Room Ceiling, Pantry, MCP Entrance, Gallery Entry, MCP Office Room, Store Room, Office Room Ceiling, Battery Room, Gallery Batt Room, HT Panel1, HT Panel2, C&R Panel`
      },
      {
        name: 'Header Count',
        param: 'header_count',
        type: 'number',
      }
    ]
  }
